// extracted by mini-css-extract-plugin
module.exports = {"card":"HgP+sdPbjxU8sGdA5of7Aw=="};